<template>
  <nav class="nav-wrap" :class="{'fixed-nav': $store.state.showNav}">
    <div class="content">
      <div class="header-logo">
        <img src="@/assets/imgs/logo.png" alt="logo">
        <span>矩尺网络</span>
      </div>
      <div class="header-menu">
        <!-- 一级菜单 -->
        <div class="menu-box" v-for="menu in menus" :key="menu.path" @mouseenter="handleMenuHover(menu)" @mouseleave="handleMenuHover()">
          <a class="menu-l1" :class="{'is-active': activeName===menu.meta.nameCN}" :href="menu.path">{{ menu.meta.nameCN }}</a>
          <template v-if="curMenuL1">
            <div class="sub-menu" v-show="menu.path===curMenuL1.path && curMenuL1.meta && curMenuL1.meta.hasSubmenu">
              <template v-for="(submenu, index) in curMenuL1.children">
                <div class="sub-menu-item" v-if="index>0" :key="submenu.path">
                  <a :href="submenu.path" :class="{'is-active': activeNameSub===submenu.name}" >{{ submenu.meta.nameCN }}</a>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
      <div class="color-image-line"></div>
    </div>
  </nav>
</template>

<script>
import menus from '@/router/menuRoutes.js'

export default {
  name: 'JcNav',
  data () {
    this.menus = menus
    return {
      curMenuL1: null,
      activeName: '首页',
      activeNameSub: '',
      hoverSubmenuName: '',
      preScrollTop: 0,
    }
  },
  watch: {
    $route: {
      handler (val) {
        const hash = val.hash
        this.activeName = val.matched[0].meta.nameCN
        this.activeNameSub = hash? hash.slice(1): ''
      },
      immediate: true
    }
  },
  mounted() {
    // 固定导航
    window.onscroll = this.scrollFun
  },
  methods: {
    scrollFun() {
      const curScrollTop = document.documentElement.scrollTop
      if(curScrollTop > 0 && this.preScrollTop < curScrollTop) { 
        //向下滚动,隐藏导航
        this.$store.commit('Set_ShowNav', false)
      } else if (curScrollTop > 0 && this.preScrollTop > curScrollTop) {
        this.$store.commit('Set_ShowNav', true)
      } else if(curScrollTop <= 0) {
        this.$store.commit('Set_ShowNav', true)
      }
      this.preScrollTop = curScrollTop
    },
    handleMenuHover(menu) {
      console.log('handleMenuHover', menu);
      this.curMenuL1 = menu
    },
    handleSubMenuHover(menu) {
      this.hoverSubmenuName = menu.name
    },
    // handleSubMenuClick(path) {
    //   if(this.$route.path === path) return
    //   this.$router.push(path)
    // }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.nav-wrap{
  position: fixed;
  z-index: 999;
  color: #717174;
  width: 100%;
  min-width: 1440px;
  height: 75px;
  top: -75px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  transition: all .3s;
  .content{
    width: 1440px;
    height: 100%;
    white-space: nowrap;
    a {
      color: #717174;
    }
    .color-image-line{
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .header-logo {
      float: left;
      margin: 0 215px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img { 
        width: 60px;
        height: 60px;
        margin-right: 10px;
      }
      span {
        font-size: $logoTextSize;
      }
    }
    .header-menu {
      float: left;
      height: 100%;
      position: relative;
      .menu-box {
        height: 100%;
        line-height: 75px;
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        padding: 0 25px;
        .menu-l1{
          display: inline-block;
          height: 24px;
          line-height: 24px;
          // color: #717174;
          font-size: 16px;
          cursor: pointer;
          background: linear-gradient(to right, $primaryColor, $primaryColor) no-repeat right bottom;
          background-size: 0 2px;
          &:not(.is-active):hover {
            background-position: left bottom;
            background-size: 100% 2px;
            color: $primaryColor;
          }
          transition: background-size .2s;
        }
        .is-active {
          color: $primaryColor;
        }
        .sub-menu{
          position: absolute;
          z-index: 999;
          background-color: rgba(0,0,0,.7);
          width: 1440px;
          height: 114px;
          left: -588px;
          top: 67px;
          display: flex;
          flex-flow: column wrap;
          align-content: flex-start;
          font-size: 14px;
          padding-left: 500px;
          padding-top: 16px;
          .sub-menu-item{
            width: 200px;
            height: 28px;
            line-height: 28px;
            text-align: left;
            .is-active {
              color: $primaryColor;
            }
            a{
              color: #fff;
            }
          }
        }
      }
    }
  }
}
.fixed-nav {
  top: 0;
}
</style>
